"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var input_base_1 = __importDefault(require("@prezzee/input-base"));
var NotchedOutline_1 = __importDefault(require("./NotchedOutline"));
var style = __importStar(require("./OutlinedInput.style"));
var form_control_1 = require("@prezzee/form-control");
var OutlinedInput = (0, react_1.forwardRef)(function (_a, ref) {
    var _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, label = _a.label, _c = _a.multiline, multiline = _c === void 0 ? false : _c, required = _a.required, _d = _a.type, type = _d === void 0 ? 'text' : _d, error = _a.error, rest = __rest(_a, ["fullWidth", "label", "multiline", "required", "type", "error"]);
    var fcs = (0, form_control_1.useFormControl)();
    return ((0, jsx_runtime_1.jsx)(input_base_1.default, __assign({ fullWidth: fullWidth, styles: { root: style.root(__assign(__assign({ error: error }, fcs), rest)), input: style.input(__assign({}, rest)) }, renderSuffix: function (_) { return ((0, jsx_runtime_1.jsx)(NotchedOutline_1.default, { label: label, notched: Boolean((rest === null || rest === void 0 ? void 0 : rest.startAdornment) || fcs.filled || fcs.focused) })); }, multiline: multiline, inputRef: ref, type: type }, rest)));
});
OutlinedInput.displayName = 'PrezzeeOutlinedInput';
exports.default = OutlinedInput;
//# sourceMappingURL=OutlinedInput.js.map